import React from "react";
import SlBet from "../../SlBet";

import Nnary from "@/modules/Nnary";
import nary from "@/modules/nary";
import { IGameTableType } from "@/types/GlobalTypes";
import { getBlueValue, getDiceSum, getRedValue, getWinDices, isBlueEven, isBlueHigh, isBlueLow, isBlueOdd, isBlueWin, isRedEven, isRedHigh, isRedLow, isRedOdd, isRedWin, isTie } from "@/modules/games/DuelDice";

export default class M39Portrait extends React.PureComponent<IGameTableType> {
	private get commonBetProps() {
		const {
			pcode, chipBase, mobile, bets, insertBet, langdata
		} = this.props;

		return ({
			pcode, chipBase, mobile, bets, insertBet,
			langStr: langdata.language_code
		});
	}

	private readonly n50Item = [
		["Odd", "n50"],
		["Even", "n50"],
		["Low", "n50"],
		["High", "n50"],
	];

	// private readonly SGroup = [
	// 	"s6", "s5", "s4", "s3", "s2", "s1",
	// 	"s2", "s3", "s4", "s5", "s6"
	// ];

	private readonly SGroup = [
		["s6", "28"], 
		["s5", "14.5"], 
		["s4", "9.5"], 
		["s3", "7.5"], 
		["s2", "5.85"], 
		["s1", "4.8"], 
		["s2", "5.85"], 
		["s3", "7.5"], 
		["s4", "9.5"], 
		["s5", "14.5"], 
		["s6", "28"]
	];

	private readonly bottomBet = [
		["Odd/Even", "Odd/Odd", "Even/Odd", "Even/Even"],
		["Low/High", "Low/Low", "High/Low", "High/High"]
	];

	/**
	 * Red / Tie / Blue
	 * also with the dice values: 1-6
	 */
	private get containerOneFragment() {
		const { commonBetProps } = this;

		const { win, langdata } = this.props;
		const [redValue, blueValue] = [
			getRedValue(win),
			getBlueValue(win)
		];

		const tie = isTie(win);
		const [redWin, blueWin] = [
			isRedWin(win),
			isBlueWin(win)
		];

		return (
			<div className="container-one sl-flex">
				<div className="red">
					<SlBet
						{...commonBetProps}
						classes="col-xs-12 sl-bet"

						bet="Red"
						group="n50"

						winStatement={redWin}

						betLabel={langdata['txt_m39_red']}
						betType="1:1"
					/>

					<div className="row">
						{
							nary(6).map(num =>
								<SlBet
									{...commonBetProps}
									key={"midleft_" + num}
									classes="col-xs-4 sl-bet"

									bet={num + " Red"}
									group="d1"

									winStatement={num === redValue}

									betLabel={num + ""}
									betType="1:4.9"
								/>
							)
						}
					</div>
				</div>

				<div className="green">
					<SlBet
						{...commonBetProps}
						classes="col-xs-12 sl-bet"

						bet="Tie"
						group="tie_all"

						winStatement={tie}

						betLabel={langdata['txt_m39_tie']}
						betType="1:4.5"
					/>

					<div className="row">
						{nary(6).map(num =>
							<SlBet
								{...commonBetProps}
								key={"topmid_" + num}
								classes="col-xs-4 sl-bet"

								bet={num + ""}
								group="tie_ind"

								winStatement={tie && num === redValue}

								betLabel={num + ""}
								betType="1:30"
							/>
						)}
					</div>
				</div>

				<div className="blue">
					<SlBet
						{...commonBetProps}
						classes="col-xs-12 sl-bet"

						bet="Blue"
						group="n50"

						winStatement={blueWin}

						betLabel={langdata['txt_m39_blue']}
						betType="1:1"
					/>

					<div className="row">
						{
							nary(6).map(num =>
								<SlBet
									{...commonBetProps}
									key={"midright_" + num}
									classes="col-xs-4 sl-bet"

									bet={num + " Blue"}
									group="d1"

									winStatement={num === blueValue}

									betLabel={num + ""}
									betType="1:4.9"
								/>
							)
						}
					</div>
				</div>
			</div>
		);
	}

	/**
	 * Odd, Even
	 * Low, High
	 */
	private get containerTwoFragment() {
		const {
			commonBetProps,
			n50Item
		} = this;

		const { win, langdata } = this.props;

		const redWinAry = [
			isRedOdd(win), isRedEven(win),
			isRedLow(win), isRedHigh(win)
		];

		const blueWinAry = [
			isBlueOdd(win), isBlueEven(win),
			isBlueLow(win), isBlueHigh(win)
		];

		return (
			<div className="container-two sl-flex">
				<div className="red flex-wrap">
					{
						n50Item.map((item, idx) => {
							const label = langdata[`txt_m39_${item[0].toLowerCase()}`]
							return (
								<SlBet
									{...commonBetProps}
									key={"topleft_" + item}
									classes="col-xs-6 sl-bet"

									bet={item[0] + " Red"}
									group={item[1]}

									winStatement={redWinAry[idx]}

									betLabel={label}
									betType="1:0.98"
								/>
							)
						})
					}
				</div>

				<div className="blue flex-wrap">
					{
						n50Item.map((item, idx) => {
							const label = langdata[`txt_m39_${item[0].toLowerCase()}`]
							return (
								<SlBet
									{...commonBetProps}
									key={"topright_" + item}
									classes="col-xs-6 sl-bet"

									bet={item[0] + " Blue"}
									group={item[1]}

									winStatement={blueWinAry[idx]}

									betLabel={label}
									betType="1:0.98"
								/>
							)
						})
					}
				</div>
			</div>
		);
	}

	/**
	 * Dice sum (orange area)
	 */
	private get containerThreeFragment() {
		const { win } = this.props;
		const diceSum = getDiceSum(win);

		return (
			<div className="container-three flex-wrap">
				{
					Nnary(2, 12).map(num =>
						<SlBet
							{...this.commonBetProps}
							key={"numrow_" + num}
							classes="orange sl-bet col-xs-2"

							bet={num + ""}
							group={this.SGroup[num - 2][0]}

							winStatement={num === diceSum}

							betLabel={num + ""}
							betType={`1:${this.SGroup[num - 2][1]}`}
						/>
					)
				}

				<div>&nbsp;</div>
			</div>
		);
	}

	/**
	 * Pairs of Odd/Even and Low/High (purple & yellow areas)
	 */
	private get containerFourFragment() {
		const {
			bottomBet,
			commonBetProps
		} = this;

		const { completeTable, win, langdata } = this.props;

		// console.log("completeTable: " + completeTable);

		if (!completeTable)
			return null;

		// Odd/Even pairs
		const [redOdd, redEven] = [
			isRedOdd(win), isRedEven(win)
		];
		const [blueOdd, blueEven] = [
			isBlueOdd(win), isBlueEven(win)
		];

		const purpleWins = [
			redOdd && blueEven,
			redOdd && blueOdd,
			redEven && blueOdd,
			redEven && blueEven
		];


		// Low/High pairs
		const [redLow, redHigh] = [
			isRedLow(win), isRedHigh(win)
		];
		const [blueLow, blueHigh] = [
			isBlueLow(win), isBlueHigh(win)
		];

		const yellowWins = [
			redLow && blueHigh,
			redLow && blueLow,
			redHigh && blueLow,
			redHigh && blueHigh
		];

		return (
			<div className="container-four flex-wrap">
				{
					// Purple row
					bottomBet[0].map((item, idx) => {
						const label = langdata[`txt_m39_${item}`]

						return (
							<SlBet
								{...commonBetProps}
								key={"bottomleft_" + item}
								classes="purple col-xs-3 sl-bet"

								bet={item}
								group="pairs"

								winStatement={purpleWins[idx]}

								betLabel={label}
								betType="1:2.93"
							/>
						)
					})
				}

				{
					// Yellow row
					bottomBet[1].map((item, idx) => {
						const label = langdata[`txt_m39_${item}`]

						return (
							<SlBet
								{...commonBetProps}
								key={"bottomright_" + item}
								classes="yellow col-xs-3 sl-bet"

								bet={item}
								group="pairs"

								winStatement={yellowWins[idx]}

								betLabel={label}
								betType="1:2.93"
							/>
						)
					})
				}
			</div>
		);
	}

	/**
	 * Any dice wins (grey area)
	 */
	private get containerFiveFragment() {
		const { completeTable, win } = this.props;

		// console.log("completeTable: " + completeTable);

		if (!completeTable)
			return null;

		const winDices = getWinDices(win);

		return (
			<div className="container-five flex-wrap">
				{
					nary(6).map(num =>
						<SlBet
							{...this.commonBetProps}
							key={"bottommid_" + num}
							classes="grey col-xs-4 sl-bet"

							bet={num + ""}
							group="any_number"

							winStatement={winDices.includes(num)}

							betLabel={num + ""}
							betType="1:2.21"
						/>
					)
				}
			</div>
		);
	}

	render() {
		return (
			<div className="sl-table m39">
				{this.containerOneFragment}
				{this.containerTwoFragment}
				{this.containerThreeFragment}
				{this.containerFourFragment}
				{this.containerFiveFragment}
			</div>
		);
	}
}
